import { render, staticRenderFns } from "./PayoutAccountNotification.vue?vue&type=template&id=321a42d2&"
import script from "./PayoutAccountNotification.vue?vue&type=script&lang=js&"
export * from "./PayoutAccountNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports